import { AuthorityLevels, DistanceUnits, VolumeAndWeightUnits } from '../enums';
import { AppDefaults, Client, Material, Truck, User, Vendor, VendorMaterialStock, Bid, UserSettings } from '../types/app';
import { NumberWithMetric } from '../types/shared';
import { emptyValues } from './empty-values';
import { firebaseEmptyField } from './firebase-values';

export const formDefaults = Object.freeze({
  numberWithMetric: {
    number: 0,
    metric: ''
  } as NumberWithMetric,
  appDefaults: {
    groupName: '',
    companyAddress: '',
    companyName: '',
    companyPhone: '',
    markup: 0,
    minTime: 0,
    bidEditTimeout: firebaseEmptyField,
    searchRadius: {
      metric: DistanceUnits.Miles,
      number: 0
    }
  } as AppDefaults,
  vendorMaterialsStockSelector: {
    material: {
      inStock: true,
      material: {
        name: ''
      },
      rate: {
        number: 0,
        metric: VolumeAndWeightUnits.Tons
      }
    } as VendorMaterialStock
  },
  vendor: {
    location: {
      geoPoint: emptyValues.geoPoint,
      address: ''
    },
    name: '',
    phone: '',
    doApplyMarkup: true,
    materials: [],
    enabled: true
  } as Vendor,
  material: {
    name: '',
    conversionRate: firebaseEmptyField
  } as Material,
  client: {
    email: '',
    name: '',
    phone: '',
    taxExempt: false
  } as Client,
  truck: {
    name: '',
    runRate: 0,
    unloadLoadTime: 0,
    timeMultiplier: 1,
    enabled: true
  } as Truck,
  user: {
    authorityLevel: AuthorityLevels.User,
    email: '',
    name: ''
  } as User,
  localBid: {
    client: emptyValues.client,
    completionDate: emptyValues.date,
    date: emptyValues.date,
    groupCompanyAddress: '',
    groupCompanyName: '',
    groupCompanyPhone: '',
    jobLocation: '',
    jobName: '',
    notes: '',
    materialList: []
  } as Bid,
  userSettings: {
    folderId: '',
    templateId: ''
  } as UserSettings
});
